import { MedicareBridgeChecklist } from './medicare-bridge.types';

export function MedicareBridgeHandoff({
  checklist,
}: {
  checklist: MedicareBridgeChecklist;
}) {
  const steps = checklist.handoffSteps ?? [];
  if (steps.length === 0) return null;

  return (
    <div className="flex flex-col gap-2" data-testid="medicare-bridge-handoff">
      <p className="text-sm font-semibold text-foreground">What happens next</p>
      <ol className="list-decimal pl-5 text-sm text-foreground">
        {steps.map((step) => (
          <li key={step}>{step}</li>
        ))}
      </ol>
      {checklist.partDDenialRequired === false && (
        <p className="text-sm text-foreground">A Part D denial is not required.</p>
      )}
    </div>
  );
}
